// Optional chaining: import.meta.env is undefined under `tsx --test` (authFlow.test.ts).
const enabled = import.meta.env?.['VITE_AUTH_DEBUG'] === 'true'

export function authLog(...args: unknown[]): void {
  if (enabled) console.log('[auth]', ...args)
}
